/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import {
  AvatarIcon,
  GlobalNavigation,
  HelpIcon,
  HomeIcon,
} from "@forge/common";
import "./ShellNavigateBar.scss";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
// import NewOrgIcon from "../../images/NewOrg.png";
// import HomeIcon from "../../images/home.png";
import React from "react";
import NavigationIcons from "../../utils/Icon-Nav/NavIcons";
import { getTenantDetailsByTenantId } from "../../store/Tenant/tenant-actions";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import UserPermissions from "../../models/apiModels/UserPermissions";
import { getUserPermissions, getUserRole } from "../../store/User/user-actions";
import { IErrorProps, Tenant, WrapperUserPermissions } from "../../models";
import ToastBarForError from "../SharedComponents/ToastBarForError";
import HeaderComponent from "../SharedComponents/Header/HeaderComponent";
// import Loader from "../Loader/Loader";
import { AppRoutes } from "../../AppRoutes";
import { StatusCode } from "../../models/apiModels/Tenant";
import Loader from "../Loader/Loader";
import updateErrorList from "../../utils/methods/updateErrorList";
import ErrorHandlingComponent from "../SharedComponents/ErrorHandlingComponent";
import { useOidc } from "@axa-fr/react-oidc";
import GetTokenValues from "../../utils/methods/GetTokenValues";
import SessionTimer from "../SessionTimer/SessionTimer";
import { ConfigurationVariables } from "../../config";
import { serverErrorClose } from "../SharedComponents/serverErrorClose";
import { setErrorPopupsusingErrorCode } from "../TenantUser/setErrorPopupsusingErrorCode";
import Sidebar from "../Layout/Sidebar/Sidebar";
import staticContent from "../../utils/staticContent.json";

const ShellNavigateBar = () => {
  // const loader = useSelector((state) => state.user.isLoadingIndicatorActive);

  const loader = useSelector(
    (state: RootState) => state?.user?.isLoadingIndicatorActive
  );
  const loaderTenant = useSelector(
    (state: RootState) => state?.cart?.isLoadingIndicatorActiveTenant
  );

  const errorRef = useRef<Array<IErrorProps>>([]);
  const [showGlobalNavigation, setShowGlobalNavigation] = useState(false);
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const hasInitializedRef = useRef(false);

  // const userPermissionsLocal = useRef<UserPermissions>();
  const userPermissionFetched = useSelector(
    (state: RootState) => state.user?.isUserPermissionsFetched
  );

  const userPermissions: WrapperUserPermissions = useSelector(
    (state: RootState) => state?.user?.userPermissions
  );

  const userpermissionRef = useRef<WrapperUserPermissions>(userPermissions);
  useEffect(() => {
    userpermissionRef.current = userPermissions;
  }, [userPermissions]);
  const tenantStatus: any = useSelector(
    (state: RootState) => state?.cart?.tenantDeatailsByTenantId?.statusCode
  );

  const tokenValues = GetTokenValues();
  const { logout } = useOidc();
  let accessTokenPayload =
    tokenValues !== undefined
      ? tokenValues.accessTokenPayload
      : {
          sub: "",
          ext: {
            customer: "",
            tenant_id: "",
          },
        };

  const tokenInfo = {
    customer: accessTokenPayload?.ext?.customer,
    tenant: accessTokenPayload?.ext?.tenant_id,
    userId: accessTokenPayload?.sub,
  };
  type MenuItems =
    | "Home"
    | "AddNewOrg"
    | "Help"
    | "DownloadPDF"

  //dispatch(userActions.setTokenInfo(tokenInfo));

  ///////////////Error Handling////////////////////////

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const toastErrors = useRef<IErrorProps[]>([]);
  const [errorListGlobal, setErrorListGlobal] = useState<Array<IErrorProps>>(
    []
  );
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);

  useEffect(() => {
    // Ensure errorRef and errorRef.current are not null or undefined
    // CID 3304394 - coverity issue fixed
    if (errorRef && errorRef.current) {
      errorRef.current = errorListGlobal;
    }
  }, [errorListGlobal]);

  const [activeMenuItem, setActiveMenuItem] = useState<MenuItems>(staticContent.home as MenuItems);

  const onDialogForServerCloseHandler = () => {
    setOpenDialogServerError(false);
    // serverErrorClose({
    //   errorListGlobal,
    //   setOpenDialogServerError,
    //   setErrorListGlobal,
    // });
  };

  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };
  // istanbul ignore next
  useEffect(() => {
    setErrorPopupsusingErrorCode({
      errorListGlobal,
      setOpenDialogNoURLError,
      setOpenToastError,
      setOpenDialogServerError,
      openDialogNoURLError,
      openToastError,
      openDialogServerError,
    });
  }, [errorListGlobal]);
  const onDialogForNOURLCloseHandler = () => {
    setOpenDialogNoURLError(false);
  };
  useEffect(() => {
    if (
      errorListGlobal.some((x) => x.errorCode === undefined) &&
      !openDialogNoURLError
    ) {
      setOpenDialogNoURLError(true);
    }

    if (errorListGlobal.some((x) => x.errorCode === 400) && !openToastError) {
      setOpenToastError(true);
    }
    if (
      errorListGlobal.some(
        (x) =>
          x.errorCode !== undefined &&
          x.errorCode !== 400 &&
          x.errorCode !== null &&
          x.errorCode !== 204
      ) &&
      !openDialogServerError
    ) {
      setOpenDialogServerError(true);
    }
  }, [errorListGlobal]);

  // Set active menu based on current path immediately on component mount
  useEffect(() => {
    if (window.location.pathname === "/" || window.location.pathname.startsWith("/tenant")) {
      setActiveMenuItem("Home");
    } else if (window.location.pathname.startsWith("/organization")) {
      setActiveMenuItem("AddNewOrg");
    }
  }, []);

  useEffect(() => {
    if (!userPermissionFetched && !hasInitializedRef.current) {
      hasInitializedRef.current = true;
      setIsLoading(true);
      // Pass tenantId from token using the hook
      const args = tokenInfo.tenant;
      
      // Execute both API calls in parallel using Promise.all
      Promise.all([
        dispatch(getUserRole(args)).unwrap(),
        dispatch(getUserPermissions(args)).unwrap()
      ])
        .then(([, permissionsData]) => {
          getTenantInfoIfUserpermissionsAreFetched(permissionsData);
        })
        .catch((err) => {
          // navigate("/error");
          setErrorListGlobal((prevState) =>
            updateErrorList(err, [...prevState])
          );
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, []);

  //Get tenant details for 1st call to get tenant details

  const getTenantInfoIfUserpermissionsAreFetched = (data: any) => {
    const parameters: {
      tenantId: string;
    } = {
      tenantId: tokenInfo.tenant,
    };

    if (userpermissionRef?.current?.can_read_tenant) {
      setIsLoading(true);

      dispatch(getTenantDetailsByTenantId(parameters))
        .unwrap()
        .then((response: any) => {
          // Only navigate to /tenant/user/ if on root path - let other pages stay where they are
          if (window.location.pathname === "/") {
            if (response.status === StatusCode.SetupCompleted) {
              navigate("/tenant/user");
            } else if (response.status === StatusCode.TenantUpdated) {
              navigate("/tenant/user");
            } else {
              navigate("/setup");
            }
          }
        })
        .catch((err) => {
          if (err?.statusCode == 404) {
            userpermissionRef?.current?.can_create_tenant
              ? navigate("/setup")
              : errorHandller("Please ask your admin to setup tenant");
          } else {
            setErrorListGlobal((prevState) =>
              updateErrorList(err.error.response, [...prevState])
            );
            // setErrorListGlobal((prevState) =>
            //   updateErrorList(err, [...prevState])
            // );
            // TODO: Need to update errors here
            // navigate("/error");
            //   #TODO
          }
        })
        .finally(() => {
          setIsLoading(false);
        });

      // dispatch(getTenantLogo(parameters.tenantId))
      //   .unwrap()
      //   .then((response: any) => {
      //     // setCurrentTenantLogo(response as string);
      //   })
      //   .catch(
      //     (err: any) => {
      //       // const newError = {
      //       //   errorCode: err.response.status,
      //       //   errorMessage: err.response.data,
      //       // };

      //       setErrorListGlobal((prevState) =>
      //         updateErrorList(err, [...prevState])
      //       );
      //     } //
      //     // seterrorgetLogo(updateErrorList(err, [...errorgetLogo]))
      //   )
      //   .finally(() => setIsLoading(false));
    } else if (userpermissionRef?.current?.can_read_organisation) {
      setActiveMenuItem("AddNewOrg");
      navigate("/organization");
    } else {
      navigate("/error");
      // const newError = {
      //   errorCode: err.response.status,
      //   errorMessage: err.response.data,
      // };
      // setErrorListGlobal((prevState) => updateErrorList(err, [...prevState]));
    }
    // }
  };

  const errorHandller = (message: string) => {
    const error: IErrorProps = {
      errorCode: 403,
      errorMessage:
        message ?? "User doesn't have privileges to perform this operation",
    };
    const errorListData: IErrorProps[] = [];
    errorListData.push(error);
    toastErrors.current = errorListData;
    setOpenToastError(true);
  };

  const clickIconHandler = (activeMenuItem: MenuItems) => {
    if (activeMenuItem == "Help") {
      setActiveMenuItem("Help");

      window.open(
        `${ConfigurationVariables.USERMANUAL_URL}/index.html`,
        "_blank"
      );
      return;
    }

    if (activeMenuItem == "DownloadPDF") {
      window.open(
        `${ConfigurationVariables.USERMANUAL_URL}/${ConfigurationVariables.DOWNLOAD_HELP_GUIDE_PDF_URL}`,
        "_blank"
      );

      setActiveMenuItem("DownloadPDF");
      return;
    }

    if (activeMenuItem === "Home") {
      if (userPermissions.can_read_tenant) {
        setActiveMenuItem("Home");

        if (tenantStatus === 200) {
          return navigate("/tenant/user");
        } else if (tenantStatus == 404 && userPermissions.can_create_tenant) {
          navigate("/setup");
        } else {
          errorHandller("User doesn't have privileges to List the Tenants");
        }
      }
    } else if (activeMenuItem == "AddNewOrg") {
      if (tenantStatus === 404) {
        errorHandller("User doesn't have privileges to list the organizations");
      } else if (userPermissions.can_read_organisation) {
        setActiveMenuItem("AddNewOrg");
        return navigate("/organization");
      } else {
        errorHandller(
          "User doesn't have privileges to list the  organizations"
        );
      }
    }
  };

  const getShowNav = (setShow: boolean) => {
    setShowGlobalNavigation(setShow);
  };

  const Logout = () => {
    logout(ConfigurationVariables.KONG_URL + "logout");
    return <></>;
  };

  const [isCollapsed, setIsCollapsed] = useState(true);

  // Memoize the toggle function to prevent unnecessary re-renders
  const handleSidebarToggle = useCallback(() => {
    setIsCollapsed((prev) => !prev);
  }, []);

  // Handle sidebar close
  const handleSidebarClose = useCallback(() => {
    setIsCollapsed(true);
  }, []);

  return (
    <>
      <div>
        <HeaderComponent
          getShowNav={getShowNav}
          suiteName="Performance"
          superScript="+"
          verticalName="for Utilities"
          suiteNameToggle={true}
          onSidebarToggle={handleSidebarToggle}
        />
      </div>

      <div className="menu-Bar theme-side-menu">
       

        <Sidebar 
          key="sidebar"
          activeMenuItem={activeMenuItem}
          handleMenuClick={clickIconHandler}
          onClose={() => {
            handleSidebarClose();
          }}
          userPermissions={userPermissions}
          isCollapsed={isCollapsed}
        />
      </div>

      {/* {showGlobalNavigation && (
        <GlobalNavigation
          menuConfig={[]}
          animated={true}
          onClose={() => {
            setShowGlobalNavigation(false);
          }}
        />
      )} */}
      <div className="container-Page">
        <div className="content-Page">
          <AppRoutes />
          <SessionTimer
            onAbsoluteTimeout={() => Logout()}
            onIdleTimeout={() => Logout()}
            //onSessionExpiry={() => LogoutUser()}
            // sessionExpiryTime={1200099}
          />
        </div>
      </div>

      <ErrorHandlingComponent
        openToast={openToastError}
        onCloseToast={handleToastBarClose}
        errorList={errorListGlobal.concat(toastErrors.current)}
        openServerError={openDialogServerError}
        onCloseServerError={onDialogForServerCloseHandler}
        openNoURL={openDialogNoURLError}
        onCloseNoURL={onDialogForNOURLCloseHandler}
        openDialogforConflict={false}
        onCloseServerConflictError={function (): void {}}
      />

      {/* {isLoading && <Loader />} */}
      {(loader || loaderTenant || isLoading) && <Loader />}
    </>
  );
};

export default ShellNavigateBar;
